import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Radio, RadioGroup } from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../../hooks";
import closeIconPng from "../../../assets/icon-close.svg";
import { maskCreditCardNumber } from "../../../Utils/validations-utils";
import {
  setNextPrimaryPaymnetId,
  setNextPrimaryMethod,
} from "../../../SharedContextStore/slices/paymentMethodDetails";
import { setOpenConfirmCVVModal } from "../../../SharedContextStore/slices/paymentMethods";
import { getquickBillPayPageContent } from "../../../SharedContextStore/slices/contents/qbpContentAem";
import { PostpaidFiberContent, QuickBillPay } from "../../../SharedComponents/contents";
import DwLogutil from "../../../Utils/DwLogutil";
import {
  EC_DW_LOGGING_STEPS,
} from "../../../../../shared/utils/Constants";
import { AddUpdatePaymentGTM } from "../../../Utils/googleTags";
import useBrightspeedUser from "../../../hooks/useUser";
import useBrightspeedHeaders from "../../../hooks/useBrightspeedHeader";
const DeletePaymentMethod = (props: any) => {
  const { onClose, listOfPayMethods, deleteSuccess } = props;
  const { isAutoPayEnrolled } = useAppSelector((state) => state?.planDetails);
  const autoPayEnrolled: boolean = isAutoPayEnrolled;
  const {
    nextPrimaryPaymnetId,
    defaultPayId,
    deletePaymentDetails,
    nextPrimaryMethod,
  } = useAppSelector((state) => state?.paymentMethodDetails);
  const companyName = useAppSelector((state) => state?.user?.companyName);
  const headers = useBrightspeedHeaders();
   const user = useAppSelector((state) => state.user.data);
  const userCompanyName = headers?.siteId;
  const dispatch = useAppDispatch();

 const { entry: postpaidcontent }: any = PostpaidFiberContent();
     // const back_autopay = postpaidcontent?.am_postpaid_fiber_autopay?.back_autopay;
     const remove_PPM_subhead = postpaidcontent?.am_postpaid_fiber_autopay?.remove_PPM_subhead;
 
   const { isPostPaidFiberUser } = useBrightspeedUser();
 

  const QBP_CONTENT_Data: any = useAppSelector(
    (state) => state.quickBillPayContent?.quickBillPayPageContent
  );

  const QBP_CONTENT_2: any = QuickBillPay();
   useEffect(() => {
    if(!QBP_CONTENT_Data) {
    dispatch(getquickBillPayPageContent());
    }
  }, []);

  const manageautopay = QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.manageautopay;
  const { accountType } = useBrightspeedUser();
  return (
    <>
      <Box 
      //  id="scroll-dialog-description"
        sx={{ width: "555px" }}
        className={"addNewPaymentMethod removePaymentMethod"}
      >
        <Typography className="modal-title font-primary" component="h2" id="scroll-dialog-title">
          {/* {`Remove ${
            deletePaymentDetails?.id === defaultPayId && autoPayEnrolled
              ? "primary"
              : ""
          } payment method?`} */}
          {
            deletePaymentDetails?.id === defaultPayId && autoPayEnrolled
              ? manageautopay?.remove_PPM_header
              : manageautopay?.remove_pay_method_header
          }
        </Typography>

        <hr role="presentation" />
        <Typography 
          sx={{
            margin: "32px 0px 0px 0px !important",
          }}
          className="modal-description"
        >
          {
            deletePaymentDetails?.id === defaultPayId && autoPayEnrolled
              ? isPostPaidFiberUser ? remove_PPM_subhead : manageautopay?.remove_PPM_subhead
              : manageautopay?.remove_pay_method_subhead
          }
          <Typography
            sx={{
              margin:
                deletePaymentDetails?.id === defaultPayId && autoPayEnrolled
                  ? ""
                  : "16px 0px 0px 0px !important",
            }}
            className="modal-description cardTypeCC"
          >
            {deletePaymentDetails && deletePaymentDetails?.paymentType === "ACH"
              ? deletePaymentDetails?.type
              : deletePaymentDetails?.creditCardType?.toLowerCase()}{" "}
            ****{" "}
            {deletePaymentDetails && deletePaymentDetails?.paymentType === "ACH"
              ? deletePaymentDetails?.bankAccountNumber?.slice(12)
              : maskCreditCardNumber(deletePaymentDetails?.cardNumber)}
          </Typography>
        </Typography>

        {deletePaymentDetails?.id === defaultPayId && autoPayEnrolled && (
          <Box>
            <Typography className="selectNewPPM">
              {manageautopay?.new_PPM_header}
            </Typography>

            {(listOfPayMethods?.creditcards ||
              listOfPayMethods?.bankAccounts) && (
              <Box className="paymentMethodLink">
                <RadioGroup className="radio-group-container">
                  {listOfPayMethods?.creditcards &&
                    listOfPayMethods?.creditcards.length > 0 &&
                    listOfPayMethods?.creditcards?.map(
                      (card: any, index: number) =>
                        card.id !== defaultPayId && (
                          <Box
                            key={card.id}
                            className="payment-group-container-Main"
                          >
                            <div className="payment-group-container">
                              <div className="payment-details">
                                <div className="payment-date-year">
                                  <div className="card-number">                                    
                                  <Box className="d-flex">                             
                                    {
                                      <Radio
                                        color="primary"
                                        size="medium"
                                        id={`popupcard-${index + 1}`}
                                        checked={
                                          card?.id === nextPrimaryPaymnetId
                                        }
                                        onChange={() => {
                                          dispatch(setNextPrimaryMethod(card));
                                          dispatch(
                                            setNextPrimaryPaymnetId(card?.id)
                                          );
                                        }}
                                        key={index + "popupcard"}
                                      />
                                    }
                                    <label className="card-number-label cardTypeCC"  htmlFor={`popupcard-${index + 1}`}>
                                      {card?.creditCardType?.toLowerCase()} ****{" "}
                                      {maskCreditCardNumber(card?.cardNumber)}
                                    </label>
                                    </Box>     
                                    <Typography
                                      sx={{ marginLeft: "24px" }}
                                      component="span"
                                      className="d-flex"
                                    >
                                      <label className="expiration-year-label">
                                        {`Exp: ${card?.expirationMonth?.toLocaleString(
                                          "en-US",
                                          {
                                            minimumIntegerDigits: 2,
                                            useGrouping: false,
                                          }
                                        )}/${card?.expirationYear}`}
                                      </label>
                                    </Typography>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Box>
                        )
                    )}

                  {listOfPayMethods?.bankAccounts &&
                    listOfPayMethods?.bankAccounts.length > 0 &&
                    listOfPayMethods?.bankAccounts
                      ?.sort((firstValue: any, secondValue: any) =>
                        firstValue.type === "Checking"
                          ? -1
                          : secondValue.type === "Checking"
                          ? 1
                          : 0
                      )
                      ?.map(
                        (bankDetails: any, index: number) =>
                          bankDetails?.id !== defaultPayId && (
                            <div
                              key={bankDetails.id}
                              className="payment-group-container-Main"
                            >
                              <div className="payment-group-container">
                                <div className="payment-details">
                                  <div className="payment-date-year">
                                    <div className="card-number">
                                    <Box className="d-flex">
                                      {
                                        <Radio
                                          color="primary"
                                          size="medium"
                                          id={`bank-${index + 1}`}
                                          checked={
                                            bankDetails?.id ===
                                            nextPrimaryPaymnetId
                                          }
                                          onChange={() => {
                                            dispatch(
                                              setNextPrimaryMethod(bankDetails)
                                            );
                                            dispatch(
                                              setNextPrimaryPaymnetId(
                                                bankDetails?.id
                                              )
                                            );
                                          }}
                                          key={index + "bank"}
                                        />
                                      }
                                      <label className="card-number-label"  htmlFor={`bank-${index + 1}`}>
                                        {bankDetails?.type} ****{" "}
                                        {bankDetails?.bankAccountNumber?.slice(
                                          12
                                        )}
                                      </label>
                                      </Box>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                      )}
                </RadioGroup>
                <Typography
                  component="div"
                  className="requiredLabel"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "16px",
                    color: "#646464",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "16px"
                  }}
                >
                  *Required
                </Typography>
              </Box>
            )}       
          </Box>
        )}
      </Box>
      <Box className="yesDelete removePayMethod">
        <Button
          color="primary"
          variant="outlined"
          onClick={() => {
            onClose(true);
             AddUpdatePaymentGTM(`remove_payment_method_cancelcta_clicked`, companyName || userCompanyName,"",accountType,user?.billingAccountNumber )
          }}
        >
          {manageautopay?.cancel_btn}
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            if (deletePaymentDetails?.id === defaultPayId && autoPayEnrolled) {
              if (
                ["CREDITCARD", "CARD", "ATM"]?.includes(
                  nextPrimaryMethod?.paymentType?.toUpperCase()
                )
              ) {
                dispatch(setOpenConfirmCVVModal(true));
                onClose(false);
              } else {
                deleteSuccess();
              }
            } else {
              DwLogutil({stepName:EC_DW_LOGGING_STEPS?.AP_delete_PM_confirm_cta })
              deleteSuccess();
            }
          }}
        >
          {manageautopay?.cta_confirm}
        </Button>
      </Box>

      <Box className="new-close-icon-cantainer">
          <Typography component="button" className="buttonText"
          onClick={() => {
            onClose(true);
            AddUpdatePaymentGTM(`remove_payment_method_cancelcta_clicked`, companyName || userCompanyName,"",accountType,user?.billingAccountNumber )
          }}>
          <img
            src={closeIconPng}
            alt="Close the dialog"
          />
          </Typography>
      </Box>
    </>
  );
};

export default DeletePaymentMethod;
